enum Status {
    INITIAL = 'initial',
    LOADING = 'loading',
    SUCCESS = 'success',
    FAILURE = 'failure'
}

export default Status;
